@if (widgetService.jobs().length) {

<div class="
    fixed
    bottom-6
    right-6
    w-[360px]
    bg-white
    rounded-2xl
    shadow-[0_8px_24px_rgba(0,0,0,0.12)]
    overflow-hidden
    z-50
  ">

  <!-- HEADER -->

  <div class="
      flex
      items-center
      justify-between
      px-4
      py-3
      border-b
      border-slate-100
    ">

    <div class="
        text-sm
        font-medium
        text-slate-700
      ">

      Uploads

    </div>

    <!-- <button
      type="button"
      class="
        text-slate-400
        hover:text-slate-600
      "
      (click)="closeAll()"
    >

      <mat-icon>
        close
      </mat-icon>

    </button> -->
    @if(canCloseAll()) {

    <button type="button" class="
    text-slate-400
    hover:text-slate-600
  " (click)="closeAll()">

      <mat-icon>
        close
      </mat-icon>

    </button>

    }

  </div>

  <!-- JOBS -->

  @for (
  job of widgetService.jobs();
  track job.id
  ) {

  <div class="
        px-4
        py-4
        border-b
        border-slate-100
      ">

    <!-- RUNNING -->

    @if (job.status === 'running') {

    <div class="
            flex
            items-start
            gap-3
          ">

      <mat-icon class="
              text-blue-500
              mt-1
            ">
        folder
      </mat-icon>

      <div class="
              flex-1
              min-w-0
            ">

        <div class="
                text-sm
                font-medium
                truncate
              ">

          {{ job.name }}

        </div>

        <div class="
    mt-1
    text-xs
    text-slate-500
  ">

          {{ job.uploadedFiles }}
          uploaded

          @if(job.failedFiles > 0) {

          •

          <span class="
        text-red-500
      ">
            {{ job.failedFiles }}
            failed
          </span>

          }

          @if(job.skippedFiles > 0) {

          •

          <span class="
        text-amber-600
      ">
            {{ job.skippedFiles }}
            skipped
          </span>

          }

        </div>

        <!-- PROGRESS -->

        <div class="
                mt-3
                h-1.5
                bg-slate-100
                rounded-full
                overflow-hidden
              ">

          <div class="
                  h-full
                  bg-primary
                  transition-all
                  duration-300
                " [style.width.%]="job.progress">
          </div>

        </div>

        <div class="
    mt-2
    flex
    justify-between
    items-center
    text-xs
  ">

          <div class="
    flex
    gap-2
    items-center
  ">

            <span class="
      text-slate-500
    ">
              {{ job.progress }}%
            </span>

          </div>

          <button type="button" class="
      text-red-600
      hover:underline
    " (click)="cancel(job.id)">

            Cancel

          </button>

        </div>

      </div>

    </div>

    }

    <!-- COMPLETED -->

    @if (job.status === 'completed') {

    <div class="flex items-center gap-3">

      <mat-icon class="text-green-600">
        check_circle
      </mat-icon>

      <div class="flex-1">

        <div class="
                text-sm
                font-medium
                text-green-700">

          {{ job.name }} - Upload complete

        </div>

        <div class="
                text-xs
                text-slate-500
              ">

          {{ job.totalFiles - job.failedFiles }} of {{job.totalFiles}}

          files uploaded

        </div>

      </div>

      <button type="button" class="
              text-xs
              text-slate-500
              hover:text-slate-700
            " (click)="close(job.id)">

        Dismiss

      </button>

    </div>
    <div class="flex justify-end">
      <isc-button type="filled" label="Process All" [disabled]="job.processingStatus === 'processing' ||
    job.processingStatus === 'completed'" (onClick)="confirmEmbed(job.id)" />
    </div>

    }

    <!-- PATIALLY COMPLETED -->
    @if (job.status === 'partial') {

    <div class="flex items-start gap-3">

      <mat-icon class="
      text-amber-500
    ">
        warning
      </mat-icon>

      <div class="flex-1">

        <div class="
        text-sm
        font-medium
        text-amber-700
      ">

          {{ job.name }} - Uploaded with warnings

        </div>

        <div class="
        text-xs
        text-slate-500
        mt-1
      ">

          {{ job.uploadedFiles }}

          of

          {{ job.totalFiles }}

          files uploaded

        </div>

        <div class="
        text-xs
        text-amber-600
        mt-1
      ">

          {{ job.totalFiles - job.uploadedFiles }}

          files were skipped or failed

        </div>

      </div>

      <button type="button" class="
      text-xs
      text-slate-500
      hover:text-slate-700
    " (click)="close(job.id)">

        Dismiss

      </button>

    </div>

    <div class="flex justify-end mt-3">

      <isc-button type="filled" label="Process Uploaded Files" [disabled]="
      job.processingStatus === 'processing' ||
      job.processingStatus === 'completed'
    " (onClick)="confirmEmbed(job.id)" />

    </div>

    }

    <!-- FAILED -->

    @if (job.status === 'failed') {

    <div class="
            flex
            items-center
            gap-3
          ">

      <mat-icon class="
              text-red-500
            ">
        error
      </mat-icon>

      <div class="
              flex-1
            ">

        <div class="
                text-sm
                font-medium
                text-red-600
              ">

          @if(job.fatalError) {

          {{job.name}} - Upload failed

          } @else {

          {{job.name}} - Upload completed with errors

          }

        </div>

        <div class="
                text-xs
                text-slate-500
              ">
          @if(job.errorMessage) {

          {{ job.errorMessage }}

          } @else {

          {{ job.failedFiles }}
          files failed

          }

        </div>

      </div>

    </div>

    }

    @if(job.status === 'cancelled') {

    <div class="
    flex
    items-center
    gap-3
  ">

      <mat-icon class="
      text-amber-500
    ">
        cancel
      </mat-icon>

      <div class="
      flex-1
    ">

        <div class="
        text-sm
        font-medium
        text-amber-600
      ">

          Upload Cancelled

        </div>

        <div class="
        text-xs
        text-slate-500
      ">

          {{ job.uploadedFiles }}

          of

          {{ job.totalFiles }}

          files uploaded

        </div>

      </div>

    </div>

    }

    <!-- FAILED FILES -->
    @if (job.failedItems.length &&! job.fatalError) {

    <div class="
            mt-4
            border-t
            pt-3
          ">

      <div class="
              text-xs
              font-medium
              text-red-600
              mb-2
            ">

        Failed Files

      </div>

      @for (
      item of job.failedItems;
      track item.file.id
      ) {

      <div class="
                flex
                items-center
                justify-between
                py-1
              ">

        <div>

          <div class="
      text-xs
      truncate
      max-w-[220px]
    " [matTooltip]="item.file.name">

            {{ item.file.name }}

          </div>

          <div class="
      text-[11px]
      text-red-500
      truncate
      max-w-[220px]
    " [matTooltip]="item.reason">

            {{ item.reason }}

          </div>

        </div>

        @if(canRetry(item)) {

        <button type="button" class="
    text-xs
    text-blue-600
    hover:underline
  " (click)="retry(item.file)">

          Retry

        </button>

        }

      </div>

      }

    </div>

    }

  </div>

  }

</div>

}